import './SearchResult.scss'

import { ResultsItemType } from '@react/SearchResults/SearchTypes'
import { ReactElement } from 'react'

export type SearchResultProps = {
  result: ResultsItemType
  label: string
}

export function SearchResult({ result, label }: SearchResultProps): ReactElement {
  return (
    <div className="saas-result__item" data-testid="search-result">
      <a href={result.url} className="saas-result__product-url" target="_blank" rel="noreferrer noopener">
        <div className="saas-result__meta" tabIndex={0}>
          <header className="saas-result__header" tabIndex={0}>
            {result.bestBet && (
              <span className="saas-result__top-result-badge" data-testid="search-result-label" dangerouslySetInnerHTML={{ __html: label }}></span>
            )}
            <h6 className="saas-result__title" data-testid="search-result-title" dangerouslySetInnerHTML={{ __html: result.title }} />
          </header>
          <div className="saas-result__outline">
            <span tabIndex={0} dangerouslySetInnerHTML={{ __html: result.description }} />
          </div>
          <div className="saas-result__info">
            <span className="saas-result__path" tabIndex={0} data-testid="search-result-url">
              {result.url}
            </span>
          </div>
        </div>
      </a>
    </div>
  )
}
